import React, {useState, useEffect} from "react";
import useWidth from "../hooks/useWidth";
import moment from "moment";
import {Box, Typography, FormControlLabel, Switch, Grid, Button} from "@mui/material";
import VerificationMetricsComponent from "../components/dashboard/verification/verification-metrics.component";
import VerificationCountComponent from "../components/dashboard/verification/verification-count.component";
import AuthenticationMetricsComponent from "../components/dashboard/authentication/authentication-metrics.component";
import AuthenticationStatusComponent from "../components/dashboard/authentication/authentication-status.component";
import AuthenticationCountComponent from "../components/dashboard/authentication/authentication-count.component";
import AnomalyDetection from "../components/dashboard/anomaly/anomaly-detection.component";
import TopProductsAnomaliesComponent from "../components/dashboard/anomaly/top-products-anomalies.component";
import TopVerificationProductsComponent from "../components/dashboard/verification/top-verification-products.component";
import GeographicDistributionComponent from "../components/dashboard/geolocation/geographic-distribution.component";
import useDashboard from "../hooks/useDashboard";
import Offline from "../assets/images/offline.png";
import CachedIcon from "@mui/icons-material/Cached";
import useDashboardResetFilterStore from "../zustand/useDashboardResetFilterStore";
import useFilters from "../hooks/useFilters";
import VerificationStatusComponent from "../components/dashboard/verification/verification-status.component";

const DashboardScreen = () => {

    const breakpoints = useWidth();

    const {setDashboardResetFilters} = useDashboardResetFilterStore();

    const {authenticationOverviewCount, getTotalVerification, getTotalVerificationByDateRange, 
        getDashboardTotalAuthenticationByStatus, dashboardOverviewCount, getDashboardVerificationOverview
    } = useDashboard();

    const {listOfCountry, getCountry} = useFilters();

    const [isToggleAuthentication, setToggleAuthentication] = useState(false);

    const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));

    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);
    
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        }
    }, []);

    useEffect(() => {
        getDashboardVerificationOverview();
        getTotalVerification();
        getDashboardTotalAuthenticationByStatus();
        getCountry();
    }, [])

    useEffect(() => {
        getTotalVerificationByDateRange(startDate, endDate);
    }, [startDate, endDate])


    const handleToggleSwitch = (e) => {
        setToggleAuthentication(e.target.checked);
    }
    
    const handleResetFilters = (e) => {
        setDashboardResetFilters(true);
    }


    return (
        <Box>
            <Grid>
                <Typography variant="h6" sx={{color: "#58565f", fontWeight: 600, fontSize: 20}}>
                    Overview
                </Typography>
            </Grid>

            {isOnline ? 
                <>
                    <Grid container>
                        <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                            <Grid container sx={{display: "block"}}>
                                <Grid sx={{textAlign: "end"}}>
                                    <FormControlLabel sx={{mr: 0}} label={<Typography sx={{color: "#58565f", fontSize: 14}}>Authentication</Typography>} 
                                        control={<Switch checked={isToggleAuthentication} onChange={handleToggleSwitch} />} 
                                    />
                                </Grid>

                                {isToggleAuthentication ?
                                    <>
                                        <AuthenticationMetricsComponent breakpoints={breakpoints} authenticationOverviewCount={authenticationOverviewCount} />
                                        <AuthenticationStatusComponent breakpoints={breakpoints} />
                                        <AuthenticationCountComponent breakpoints={breakpoints} />
                                    </>
                                :
                                    <>
                                        <VerificationMetricsComponent 
                                            breakpoints={breakpoints}
                                            dashboardOverviewCount={dashboardOverviewCount}
                                        />

                                        <VerificationStatusComponent 
                                            breakpoints={breakpoints}
                                        />

                                        <VerificationCountComponent breakpoints={breakpoints} />
                                    </>
                                }
                            </Grid>
                        </Grid>

                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                            <Box sx={{textAlign: "end"}}>
                                <Button variant="contained" sx={{height: "33px", textTransform: "none", backgroundColor: "#5959D8", color: "#fff", "&:hover": {backgroundColor: "#5959D8", color: "#fff"}}}
                                    startIcon={<CachedIcon />} onClick={(e) => handleResetFilters(e)}
                                >
                                    Reset Filters
                                </Button>
                            </Box>
                           
                            <AnomalyDetection breakpoints={breakpoints} />
                            <TopProductsAnomaliesComponent breakpoints={breakpoints} />
                            <TopVerificationProductsComponent breakpoints={breakpoints} />
                        </Grid>
                    </Grid>

                    <Grid container sx={{mt: "19px", backgroundColor: "#fff", borderRadius: "8px", p: "24px", width: "100%", height: "100%", display: "block"}}>
                        <GeographicDistributionComponent breakpoints={breakpoints} listOfCountry={listOfCountry} />
                    </Grid>
                </>
            :
                <Box sx={{textAlign: 'center', mt: 20}}>  
                    <img alt="" src={Offline} style={{height: 80, marginBottom: 20}} />

                    <Typography sx={{fontSize: 20, fontWeight: "bold", mb: 0.5, color: "#58565f"}}>
                        Ooops!
                    </Typography>

                    <Typography sx={{color: "#58565fd4"}}>
                        Failed to load data.
                    </Typography>

                    <Typography sx={{color: "#58565fd4"}}>
                        Please check your internet connection or try again.
                    </Typography>

                    <Button variant="contained" sx={{mt: 2.5, bgcolor: '#3333cf', textTransform:'none'}} onClick={() => window.location.reload()} >Try again</Button>
                </Box>
            }
        </Box>
    )

}

export default DashboardScreen